import { render, staticRenderFns } from "./HotColumn.vue?vue&type=template&id=17ba4514&scoped=true&"
import script from "./HotColumn.vue?vue&type=script&lang=js&"
export * from "./HotColumn.vue?vue&type=script&lang=js&"
import style0 from "./HotColumn.vue?vue&type=style&index=0&id=17ba4514&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ba4514",
  null
  
)

export default component.exports